var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPropertyIconGuesthouse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    transform: "translate(442 773)",
    fill: "red"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-442 -773)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.07,3a.676.676,0,0,0-.253.066L3.385,6.614A.676.676,0,0,0,3,7.223V18.54a.676.676,0,0,0,.676.676h8.107a.676.676,0,0,0,.676-.676V9.757h2.7V18.54a.676.676,0,0,0,.676.676h2.7a.676.676,0,0,0,.676-.676V7.223a.676.676,0,0,0-.385-.61L11.4,3.067A.676.676,0,0,0,11.07,3Zm.037,1.425,6.756,3.222V17.864H16.512V9.081a.676.676,0,0,0-.676-.676h-3.93a.644.644,0,0,0-.235,0H6.378a.676.676,0,0,0-.676.676v8.783H4.351V7.648ZM7.054,9.757h4.054v8.107H7.054ZM9.07,12.449a.676.676,0,0,0-.665.686v1.351a.676.676,0,1,0,1.351,0V13.135a.676.676,0,0,0-.686-.686Z",
    transform: "translate(441 772)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropertyIconGuesthouse);
export default __webpack_public_path__ + "static/media/property-icon-guesthouse.d7df4bd4b25597ad7b465854f21c52b3.svg";
export { ForwardRef as ReactComponent };